
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk/company-secretary",
      function () {
        return require("private-next-pages/hk/company-secretary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hk/company-secretary"])
      });
    }
  